import docCookies from 'doc-cookies';

export default function navbar() {
  return {
    smallShadow: false,
    open: false,
    height: 0,
    currentNamespace: 'individual', // Defaultní hodnota, pokud není nic v cookies

    init() {
      this.detectNamespace();
      this.handleScroll();
    },

    detectNamespace() {
      const path = window.location.pathname;

      if (path.includes('/individualni-plavby')) {
        this.currentNamespace = 'individual';
      } else if (path.includes('/plavby-s-dopravou-a-delegate')) {
        this.currentNamespace = 'delegate';
      } else {
        // Pokud je uživatel na rozcestníku "/", ponecháme výchozí hodnotu
        if (path !== '/') {
          this.currentNamespace =
            docCookies.getItem('current_namespace') || 'individual';
        }
      }

      // Uložit hodnotu do cookies
      docCookies.setItem(
        'current_namespace',
        this.currentNamespace,
        365 * 24 * 60 * 60
      );

      // Nastavit třídu podle aktuálního namespace
      this.updateNavbarColor();
    },

    updateNavbarColor() {
      const navbar = document.getElementById('navbar');
      if (!navbar) return;

      navbar.classList.remove('navbar--blue', 'navbar--white');
      navbar.classList.add(
        this.currentNamespace === 'individual'
          ? 'navbar--blue'
          : 'navbar--white'
      );
    },

    handleScroll() {
      window.addEventListener('scroll', () => {
        this.smallShadow = window.scrollY > 50;
      });
    },

    toggleMenu() {
      this.open = !this.open;
      this.height = this.open
        ? document.querySelector('.navbar__content').scrollHeight
        : 0;
    },
  };
}
